import { render } from "./AssigneeIcon.vue?vue&type=template&id=bee3a650"
import script from "./AssigneeIcon.vue?vue&type=script&lang=js"
export * from "./AssigneeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__